<template>
  <div class="details" ref="all">
    <div class="info-mid">
      
      <div class="info-mid-eve in-col">
        <div class="ws colcc hs mr">发布人</div>
        <div class="hs" v-if="user.createby_name">{{user.createby_name}}</div>
      </div>
      <div class="info-mid-eve">
        <div class="ws colcc hs mr ">发布日期</div>
        <div class="hs" v-if="user.create_time">{{user.create_time.substr(0, 10)}}</div>
      </div>
      <div class="info-mid-eve in-col" v-if="user.task_mech == '悬赏' && user.task_tag != 'PAB顾问'">
        <div class="ws colcc hs mr">限定人数</div>
        <div class="hs">{{user.max_pick}} 人</div>
      </div>
      <div class="info-mid-eve" v-if="user.task_mech == '悬赏' && user.task_tag != 'PAB顾问'">
        <div class="ws colcc hs mr">已领人数</div>
        <div class="hs">{{user.take_count}} 人</div>
      </div>
      <!-- <div class="info-mid-eve mr">
        <div class="ws colcc hs">任务状态</div>
        <div class="hs">{{user.status }} </div>
      </div> -->
      <div class="info-mid-eve mr" v-if="user.maintain_days > 0">
        <div class="ws colcc hs">维护期</div>
        <div class="hs colo">{{user.maintain_days}}天</div>
      </div>
      <div class="info-mid-eve" v-if="user.content">
        <div><div class="ws colcc hs mr">任务说明</div></div>
        <div class="dh moreText" v-html="(user.content.substring(0,size) + '...')" v-if="contentShow && user.content.length > size" ref="moreText"></div>
        <div class="dh" v-html="user.content" v-else ref="moreText"></div>
        <div class="more" v-if="contentShow && user.content.length > size" @click="contentShow = false">查看全部</div>
        <div class="more" v-else-if="user.content.length > size" @click="contentShow = true">收起</div>
      </div>
      <div class="info-mid-eve" v-if="user.criteria">
        <div><div class="ws colcc hs mr">验收标准</div></div>
        <div class="dh moreText" v-html="(user.criteria.substring(0,size) + '...')" v-if="criteriaShow && user.criteria.length > size"></div>
        <div class="dh" v-html="user.criteria" v-else></div>
        <div class="more" v-if="criteriaShow && user.criteria.length > size" @click="criteriaShow = false">查看全部</div>
        <div class="more" v-else-if="user.criteria.length > size" @click="criteriaShow = true">收起</div>
      </div>
      <div class="info-xiang-eve"  v-if="user.TaskFiles && user.TaskFiles.length">
        <div class="ws colcc hs mr">背景材料</div>
        <div class="colo ">
          <div class="mr hs" v-for="item in user.TaskFiles" :key="item.id"><a :href="item.file_path">{{item.original_name}}</a></div>
        </div>
      </div>
      <div class="info-mid-eve">
        <div><div class="ws colcc hs mr" v-if="user.svn_path">svn地址</div></div>
        <div class="dh wr">{{user.svn_path}}</div>
      </div>
      <div class="info-mid-eve" v-if="user.wx_qrcode && user.wx_qrcode != 'nobody'">
        <div><div class="ws colcc hs mr">群二维码</div></div>
        <img class="info-wechart" :src="showlist" @click="shows" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import { getIdTask } from '@/api/api/task'
import { ImagePreview } from 'vant'

export default {
  data() {
    return {
      user: {},
      task_id: null,
      showlist: '',
      content: null,
      contentShow: true,
      criteria: null,
      criteriaShow: true,
      size: 50
    }
  },
  components: {
  },
  created() {
    this.task_id = this.$route.query.task_id
    this.getTask(this.task_id)
  },
  methods: {
    getTask(s) {
      this.$showLoading()
      getIdTask(s, this.$route.query.uid).then(data => {
        if (data.data.errorCode == 0) {
          this.user = data.data.data
          if(!data.data.data.wx_qrcode) {
            console.log(6666)
            this.showlist = data.data.data.wx_qrcode
          }
        }
        this.$hideLoading()
      })
    },
    shows() {
      ImagePreview({
        images: [this.showlist],
        showIndex: false
      })
    }
  },
  watch: {
    user:function() {
      setTimeout(() => {
        console.log(this.$refs.moreText,this.$refs.moreText.clientWidth, this.user)
        if (this.$refs.moreText.clientWidth < 375) {
          console.log((this.$refs.moreText.clientWidth / 14).toFixed(), this.$refs.moreText.clientWidth)
          this.size = (this.$refs.moreText.clientWidth / 14 * 3 +1).toFixed()
        } else if (this.$refs.moreText.clientWidth < 500) {
          this.size = (this.$refs.moreText.clientWidth / 18 * 3 +1).toFixed()
        } else {
          this.size = (this.$refs.moreText.clientWidth / 20 * 3 +1).toFixed()
        }
        console.log(this.size, this.user.criteria.length)
      })
    }
  }
}
</script>

<style lang="scss">
.details {
  .info-jio {
    width: 100%;
    height: 56px;
  }
  .info-msg {
    padding: 15px 15px 20px 15px;
    background: white;
    margin-bottom: 15px;
    .info-xiang-title {
      font-weight: 700;
      height: 21px;
      line-height: 21px;
      margin-bottom: 15px;
    }
    .info-xiang-eve {
      display: flex;
      .bigw {
        width: 250px;
      }
    }
  }
  .info-xiang {
    padding: 15px 15px 20px 15px;
    background: white;
    margin-bottom: 15px;
    .info-xiang-title {
      font-weight: 700;
      height: 21px;
      line-height: 21px;
      margin-bottom: 15px;
    }
    .info-xiang-eve {
      display: flex;
      margin-bottom: 12px;
    }
  }
  .info-mid {
    padding: 15px 15px 20px 15px;
    background: white;
    margin-bottom: 15px;
    .info-mid-eve {
      position: relative;
      display: flex;
      padding-bottom: 12px;
      line-height: 18px;
      .info-wechart {
        width: 84px;
        height: 84px;
      }
      .more {
        font-size: 12px;
        color: blue;
        bottom: 6px;
        left: 77px;
        position: absolute;
      }
    }
    .in-col {
      float:left;
      width:50%
    }
    .info-mid-title {
      font-weight: 700;
      height: 21px;
      line-height: 21px;
      margin-bottom: 15px;
    }
    .info-xiang-eve {
      display: flex;
      margin-bottom: 12px;
    }
  }
  .info-header {
    height: 137px;
    background: white;
    padding: 15px 15px 20px 15px;
    margin-bottom: 10px;
    .info-header-foo {
      height: 20px;
      line-height: 20px;
      display: flex;
    }
    .info-header-main {
      display: flex;
      height: 20px;
      line-height: 20px;
      margin-bottom: 12px;
      .info-main {
        display: flex;
        .pdl {
          width: 103px;
        }
      }
    }
    .info-header-title {
      height:25px;
      font-weight: 700;
      font-size:18px;
      color:rgba(51,51,51,1);
      line-height:25px;
      margin-bottom: 25px;
    }
  }
  .info-msg-img {
    height: 18px;
    width: 18px;
  }
  .colcc {
    color: #999999;
  }
  .colo {
    color: #BE0000;
  }
  .colb {
    color: #0067DF;
  }
  .ws {
    width: 77px;
  }
  .wr {
    word-break:break-all;
  }
  // .hs {
  //   height: 20px;
  //   line-height: 20px;
  // }
  .mr {
    // margin-bottom: 12px;
  }
  .dh {
  }
  .bh {
    margin-bottom: 5px;
  }
  .moreText {
    padding-bottom: 14px;
  }
}
</style>